import Vue, { computed } from "vue";
const SCREEN_SIZE_MD = 1024;
const SCREEN_SIZE_LG = 1440;
const $q = Vue;
const mobile = computed(() => {
  return SCREEN_SIZE_MD > ($q == null ? void 0 : $q.screen.width);
});
const tablet = computed(() => {
  const screenWidth = $q == null ? void 0 : $q.screen.width;
  return SCREEN_SIZE_MD <= screenWidth && SCREEN_SIZE_LG > screenWidth;
});
const desktop = computed(() => {
  return SCREEN_SIZE_LG <= ($q == null ? void 0 : $q.screen.width);
});
export {
  desktop,
  mobile,
  tablet
};
//# sourceMappingURL=deviceInfo.es.js.map
